import http from "@/utils/request";

// 获取职员列表
export function adminList(data: Req.adminList) {
  return http.post<Res.response<Res.adminList[]>>({
    url: "/merchant/sys/admin/list",
    data,
  });
}
//添加职员
export function addSysAdmin(data: Req.addSysAdmin) {
  return http.post<Res.response<any>>({
    url: "/merchant/sys/admin/add",
    data,
  });
}
//修改职员
export function editSysAdmin(data: Req.addSysAdmin) {
  return http.post<Res.response<any>>({
    url: "/merchant/sys/admin/update",
    data,
  });
}
//修改职员
export function updateSysAdminFiled(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/sys/admin/updateSysAdminFiled",
    data,
  });
}
//职员详情
export function sysAdminInfo(data: string) {
  return http.get<Res.response<any>>({
    url: "/merchant/sys/admin/info/" + data,
    data,
  });
}
//获取角色简要列表
export function roleListSimple() {
  return http.post<Res.response<Res.roleListSimple[]>>({
    url: "/merchant/sys/role/listSimple",
  });
}
// 获取角色列表
export function sysRoleList(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/sys/role/list",
    data,
  });
}
//获取角色详情
export function roleInfo(data: string) {
  return http.get<Res.response<any>>({
    url: "/merchant/sys/role/info/" + data,
    data,
  });
}
// 添加角色获取所有的菜单
export function merchantResourceDto() {
  return http.post<Res.response<any>>({
    url: "/merchant/sys/resource/getMerchantResourceDto",
  });
}
//添加职员
export function roleadd(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/sys/role/add",
    data,
  });
}
// 修改职员
export function roleUpdate(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/sys/role/update",
    data,
  });
}
// 删除角色
export function deleterole(data: any) {
  return http.delete<Res.response<any>>({
    url: "/merchant/sys/role/delete/" + data,
  });
}
// 添加角色
export function addrole(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/sys/role/add",
    data,
  });
}
// 查询客户

export function listMerchants(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/sys/admin/listMerchants",
    data,
  });
}
// 导出
export function exportListMerchants(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/sys/admin/exportListMerchants",
    data,
    responseType: "blob",
    // headers: {
    //   "Content-Type": "application/json; charset=utf-8",
    // },
  });
}
//重置密码

export function restPassword(data: any, data2: any) {
  return http.get<Res.response<any>>({
    url: "/merchant/sys/admin/restPassword?userId=" + data + "&command=" + data2,
  });
}
